import { Action } from '@ngrx/store';

export enum ActionTypes {
  ALL_RELATIONSHIPS = '[RELATIONSHIP]   Relationship Request',
  ALL_RELATIONSHIPS_COMPLETE = '[RELATIONSHIP]  Relationship Complete',
  ALL_RELATIONSHIPS_FAILURE = '[RELATIONSHIP]  Relationship Failure',

  IMPERSONATE_USER_RELATIONSHIPS = '[RELATIONSHIP] Client Relationship Request',
  IMPERSONATE_USER_RELATIONSHIPS_COMPLETE = '[RELATIONSHIP] Client Relationship Complete',
  IMPERSONATE_USER_RELATIONSHIPS_FAILURE = '[RELATIONSHIP] Client Relationship FAILURE',

  ALL_INVITELIST = '[INVITE]   invite Request',
  ALL_INVITE_COMPLETE = '[INVITE]  invite Complete',
  ALL_INVITE_FAILURE = '[INVITE]  invite Failure',

  ALL_CLIENT_GROUPS = '[CLIENT GROUPS]  Request',
  ALL_CLIENT_GROUPS_COMPLETE = '[CLIENT GROUPS] Complete',
  ALL_CLIENT_GROUPS_FAILURE = '[CLIENT GROUPS] Failure',

  MY_SUGGESTIONS= '[SUGGESTION]  Request',
  MY_SUGGESTIONS_COMPLETE = '[SUGGESTION] Complete',
  MY_SUGGESTIONS_FAILURE = '[SUGGESTION] Failure',
}

export class AllInvites implements Action {
  readonly type = ActionTypes.ALL_INVITELIST;
}
export class AllInvitesComplete implements Action {
  readonly type = ActionTypes.ALL_INVITE_COMPLETE;
  constructor(public payload: any) {}
}

export class AllInvitesFailure implements Action {
  readonly type = ActionTypes.ALL_INVITE_FAILURE;
  constructor(public payload: any) {}
}

export class impersonateUserRelationships implements Action {
  readonly type = ActionTypes.IMPERSONATE_USER_RELATIONSHIPS;
  constructor(public payload?: any) {}
}

export class impersonateUserRelationshipsComplete implements Action {
  readonly type = ActionTypes.IMPERSONATE_USER_RELATIONSHIPS_COMPLETE;
  constructor(public payload: any) {}
}

export class impersonateUserRelationshipsFailure implements Action {
  readonly type = ActionTypes.IMPERSONATE_USER_RELATIONSHIPS_FAILURE;
  constructor(public payload: any) {}
}

export class AllRelationships implements Action {
  readonly type = ActionTypes.ALL_RELATIONSHIPS;
  constructor(public payload?: any) {}
}

export class AllRelationshipsComplete implements Action {
  readonly type = ActionTypes.ALL_RELATIONSHIPS_COMPLETE;
  constructor(public payload: any) {}
}

export class AllRelationshipsFailure implements Action {
  readonly type = ActionTypes.ALL_RELATIONSHIPS_FAILURE;
  constructor(public payload: any) {}
}

export class AllClientGroups implements Action {
  readonly type = ActionTypes.ALL_CLIENT_GROUPS;
  constructor(public payload?: any) {}
}

export class AllClientGroupsComplete implements Action {
  readonly type = ActionTypes.ALL_CLIENT_GROUPS_COMPLETE;
  constructor(public payload: any) {}
}

export class AllClientGroupsFailure implements Action {
  readonly type = ActionTypes.ALL_CLIENT_GROUPS_FAILURE;
  constructor(public payload: any) {}
}
export class MySuggestions implements Action {
  readonly type = ActionTypes.MY_SUGGESTIONS;
  constructor(public payload?: any) {}
}

export class MySuggestionsComplete implements Action {
  readonly type = ActionTypes.MY_SUGGESTIONS_COMPLETE;
  constructor(public payload: any) {}
}

export class MySuggestionsFailure implements Action {
  readonly type = ActionTypes.MY_SUGGESTIONS_FAILURE;
  constructor(public payload: any) {}
}

export type Actions =
  | impersonateUserRelationships
  | impersonateUserRelationshipsComplete
  | AllRelationships
  | AllRelationshipsComplete
  | AllInvites
  | AllInvitesComplete
  | AllClientGroups
  | impersonateUserRelationshipsFailure
  | AllRelationshipsFailure
  | AllInvitesFailure
  | AllClientGroupsFailure
  | AllClientGroupsComplete
  | MySuggestions
  | MySuggestionsComplete
  | MySuggestionsFailure;
